import React from "react";


import { useMediaQuery } from "@mui/material";


import Navbar from "./NavBar/Navbar";

import Abouts from "./NavBar/About";
import AboutRoadmapDivider from "./NavBar/AboutRoadmapDivider";
import Roadmap from "./NavBar/Roadmap";

import Banner from "./NavBar/Banner";
import FallingFlowers from "./NavBar/FallingFlowers";
import Slide from './NavBar/TextSlide'
import BeforeFooter from "./NavBar/BeforeFooter";
import Footers from "./NavBar/Footer";
import ThreeFooter from './NavBar/ThreeFooter'
import Slider from './NavBar/Sliders'
import Tokenomics from "./NavBar/Tokenomics";
import VideoGallery from "./NavBar/VideoGallery";



const Home = () => {
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));



  return (
    <div className="mainContent">


<div className="garden">
      {/* THIS JAVASCRIPT CODE IS FOR Header of the Park Page*/}

      {/* <Slider /> */}
      {!smallScreen && (
        <div className="desk">
           <div className="deskz">
          <Navbar/>

        <Banner/>

        <div className="sections-with-flowers">
          <FallingFlowers />
        <Slide/>






        <Abouts/>
        <AboutRoadmapDivider />

<Roadmap/>
        <ThreeFooter/>
         <Tokenomics/>
           <VideoGallery/>
           <Slide/>
           <Slider/>

  <BeforeFooter/>
          <Footers/>

        </div>
        </div>
     </div>
      )}
      {/* THIS JAVASCRIPT CODE IS FOR the Slider used for the Desktop View when you press on CustomSlider with ctrl and right arrow you move towards the Slider Page Desktop View*/}
      {smallScreen && (
   <div className="mob">
          <div className="deskz">
           <Navbar/>
             <Banner/>

        <div className="sections-with-flowers">
          <FallingFlowers />
          <Slide/>
               <Abouts/>
               <AboutRoadmapDivider />
<Roadmap/>
      <ThreeFooter/>
      <Tokenomics/>
               <VideoGallery/>
               <Slide/>
               <Slider/>
   <BeforeFooter/>
               <Footers/>
       </div>
        </div>
    </div>
      )}
      {/* THIS JAVASCRIPT CODE IS FOR the Slider used for the Mobile View when you press on MobileSlider with ctrl and right arrow you move towards the Slider Page Mobile View*/}
    </div>
     
      

   
    </div>
  );
};

export default Home;
